import { c as _c } from "react/compiler-runtime";
import { DOC_REQUEST_KIND } from '@/idv2/features/collect-document/types';
import type { ReceivedImagePayload } from '../../../types';
import { useNonIdDocMachine } from '../../context/non-id-doc-context';
import useDocName from '../../use-doc-name';
import MobileRetryView from './mobile-retry-view';
const MobileRetry = () => {
  const $ = _c(16);
  const [state, dispatch] = useNonIdDocMachine();
  const {
    requirement,
    hasBadConnectivity,
    errors,
    allowPdf
  } = state.context;
  const {
    kind: documentRequestKind
  } = requirement.config;
  const docName = useDocName(requirement.config);
  const hideUploadButton = requirement.uploadSettings === "capture_only_on_mobile" || requirement.uploadSettings === "require_mobile_capture";
  let t0;
  if ($[0] !== errors) {
    t0 = errors || [];
    $[0] = errors;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = documentRequestKind !== DOC_REQUEST_KIND.proofOfSsn;
  let t2;
  let t3;
  let t4;
  if ($[2] !== dispatch) {
    t2 = payload => dispatch({
      type: "receivedDocument",
      payload
    });
    t3 = () => dispatch({
      type: "startImageCapture"
    });
    t4 = () => dispatch({
      type: "navigatedToPrompt"
    });
    $[2] = dispatch;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== allowPdf || $[7] !== docName || $[8] !== hasBadConnectivity || $[9] !== hideUploadButton || $[10] !== t0 || $[11] !== t1 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <MobileRetryView docName={docName} errors={t0} hasBadConnectivity={hasBadConnectivity} allowPdf={allowPdf} hideUploadButton={hideUploadButton} uploadFirst={t1} onComplete={t2} onTakePhoto={t3} onBack={t4} />;
    $[6] = allowPdf;
    $[7] = docName;
    $[8] = hasBadConnectivity;
    $[9] = hideUploadButton;
    $[10] = t0;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
export default MobileRetry;